import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2930e562"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "TournamentAdvancedMatchSetRoundsMode mathsetrounds",
  style: {"overflow":"hidden !important","display":"flex","flex-direction":"column","flex-wrap":"nowrap","width":"100%"}
}
const _hoisted_2 = { style: {"display":"flex","justify-content":"center","align-items":"center","margin-block":"12px"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_4 = {
  id: "showtournamentAdvancedMatchSetRoundsMode",
  style: {"position":"sticky","top":"0","z-index":"15"}
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "flex md5 playerNameCenter" }
const _hoisted_7 = { class: "scoreBoardHeadlinePlayerName" }
const _hoisted_8 = { class: "flex md2" }
const _hoisted_9 = { class: "scoreBoardHeadline" }
const _hoisted_10 = { class: "flex md5 playerNameCenter" }
const _hoisted_11 = { class: "scoreBoardHeadlinePlayerName" }
const _hoisted_12 = { style: {"height":"100%","display":"flex","flex-direction":"column","flex-wrap":"nowrap","width":"100%"} }
const _hoisted_13 = {
  class: "row",
  style: {"position":"sticky","top":"60px","z-index":"10"}
}
const _hoisted_14 = {
  class: "flex md5 mt-4",
  style: {"margin-top":"4px!important"}
}
const _hoisted_15 = { style: {"display":"inline-block","float":"left"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Snit: ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { style: {"float":"right"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md2 mt-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "arrowsUsedHeader" })
], -1))
const _hoisted_20 = {
  class: "flex md5 mt-4",
  style: {"margin-top":"4px!important"}
}
const _hoisted_21 = { style: {"display":"inline-block","float":"right"} }
const _hoisted_22 = { style: {"float":"left"} }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Snit: ")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = {
  class: "va-table-responsive tableScroll",
  style: {"flex-grow":"1 !important"}
}
const _hoisted_26 = {
  class: "va-table va-table--striped scores",
  style: {"width":"100%"},
  ref: "scoreTableView"
}
const _hoisted_27 = ["id"]
const _hoisted_28 = {
  key: 0,
  class: "center"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "dartsthrown center" }
const _hoisted_31 = {
  key: 2,
  class: "center"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "row justify--center"
}
const _hoisted_34 = { class: "flex" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Accepter resultatet")
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { style: {"display":"flex"} }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Annullere")
const _hoisted_39 = {
  style: {"width":"100%"},
  class: "numpadTable"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Godkend")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center" }, "Nulstil Advarsel", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center" }, "Er du sikker på at du vil nulstille sættet? Alle oplysninger bliver slettet!", -1))
const _hoisted_45 = { class: "row justify--center" }
const _hoisted_46 = { class: "flex" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center mb-2" }, "Vælg antal dartpile brugt ved lukningen", -1))
const _hoisted_50 = { class: "layout gutter--xl" }
const _hoisted_51 = { class: "row justify--center align--center" }
const _hoisted_52 = { class: "flex justify--center align--center finalMatchSetRoundsClosingDartsModal" }
const _hoisted_53 = { class: "dart-main-container" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "row justify--center" }
const _hoisted_56 = { class: "flex" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center mb-2" }, "Dart 43 afslutning", -1))
const _hoisted_59 = { class: "layout gutter--xl" }
const _hoisted_60 = { class: "row justify--center align--center" }
const _hoisted_61 = { class: "flex md4 dartFourthythreeModal" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hvem vandt sættet?", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_64 = { class: "row justify--center" }
const _hoisted_65 = { class: "flex" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_67 = /*#__PURE__*/_createTextVNode("Annullere")
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center mb-2" }, "Forsætter kampen", -1))
const _hoisted_69 = { class: "layout gutter--xl" }
const _hoisted_70 = { class: "row justify--center align--center" }
const _hoisted_71 = { class: "flex md6 resumeMatchSetModal" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Vælg hvilken spiller, der skal start først", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_74 = { class: "row justify--center" }
const _hoisted_75 = { class: "flex" }
const _hoisted_76 = /*#__PURE__*/_createTextVNode("Fortsæt")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_option_list = _resolveComponent("va-option-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_va_button, {
        class: "btn",
        color: "success",
        onClick: _ctx.goBackToTournamentMatchPage
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.setPlayersNameFormate(_ctx.scoreBoardHeadText[1])), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.playersTotalMatchSetScoreForTheMatch[1]) + " - " + _toDisplayString(_ctx.playersTotalMatchSetScoreForTheMatch[0]), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.setPlayersNameFormate(_ctx.scoreBoardHeadText[0])), 1)
        ]),
        _createVNode(_component_it_divider)
      ])
    ]),
    _createVNode(_component_va_card, {
      color: "#afcfff",
      stripe: "",
      "stripe-color": "#ab0033",
      style: {"flex-grow":"1"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, [
                _createElementVNode("span", {
                  class: _normalizeClass((_ctx.roundsModeData.readOnlyMode ? 'averagescore' : 'averagescorehidden')),
                  style: {"float":"left"}
                }, [
                  _hoisted_16,
                  _hoisted_17,
                  _createTextVNode(_toDisplayString(_ctx.getPlayersAverageScore()[1]), 1)
                ], 2),
                _createElementVNode("span", _hoisted_18, [
                  _createVNode(_component_va_chip, {
                    class: _normalizeClass((_ctx.roundsModeData.readOnlyMode ? 'pointRemainingChip pointRemainingChipReadOnly' : 'pointRemainingChip')),
                    color: (_ctx.roundsModeData.currentPlayerWhoseTurnItIs ? '#fff' : '#ab0033'),
                    square: "",
                    readonly: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", {
                        class: _normalizeClass((_ctx.roundsModeData.readOnlyMode ? 'pointRemaining pointRemainingReadOnly' : 'pointRemaining')),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setRemainingToEdit(1)))
                      }, _toDisplayString(_ctx.getPlayersPointsRemaining()[1]), 3)
                    ]),
                    _: 1
                  }, 8, ["class", "color"])
                ])
              ])
            ]),
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, [
                  _createVNode(_component_va_chip, {
                    class: _normalizeClass((_ctx.roundsModeData.readOnlyMode ? 'pointRemainingChip pointRemainingChipReadOnly' : 'pointRemainingChip')),
                    color: (!_ctx.roundsModeData.currentPlayerWhoseTurnItIs ? '#fff' : '#ab0033'),
                    square: "",
                    readonly: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", {
                        class: _normalizeClass((_ctx.roundsModeData.readOnlyMode ? 'pointRemaining pointRemainingReadOnly' : 'pointRemaining')),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setRemainingToEdit(0)))
                      }, _toDisplayString(_ctx.getPlayersPointsRemaining()[0]), 3)
                    ]),
                    _: 1
                  }, 8, ["class", "color"])
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass((_ctx.roundsModeData.readOnlyMode ? 'averagescore' : 'averagescorehidden')),
                  style: {"float":"right"}
                }, [
                  _hoisted_23,
                  _hoisted_24,
                  _createTextVNode(_toDisplayString(_ctx.getPlayersAverageScore()[0]), 1)
                ], 2)
              ])
            ]),
            _createVNode(_component_it_divider)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("table", _hoisted_26, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.retrieveAndShowScore(), (tournamentmatchsetroundscore, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    id: (index === _ctx.retrieveAndShowScore().length -1) ? 'lastRow' : `row${index}`
                  }, [
                    (index >= _ctx.getNumberOfRoundsPlayedByPlayer(true))
                      ? (_openBlock(), _createElementBlock("td", _hoisted_28, "---"))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 1,
                          class: "center",
                          onClick: ($event: any) => (_ctx.setScoreToEdit({ score: tournamentmatchsetroundscore[1], turnIndex: index, playerTurn: 1 }))
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass((_ctx.isEditScore && _ctx.scoreDataForEdit.turnIndex == index && _ctx.scoreDataForEdit.playerTurn == 1) && 'selectedField')
                          }, _toDisplayString(tournamentmatchsetroundscore[1]), 3)
                        ], 8, _hoisted_29)),
                    _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.getMaxValueOfNumberOfDartArrowsThrown(index)), 1),
                    (index >= _ctx.getNumberOfRoundsPlayedByPlayer(false))
                      ? (_openBlock(), _createElementBlock("td", _hoisted_31, "---"))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 3,
                          class: "center",
                          onClick: ($event: any) => (_ctx.setScoreToEdit({ score: tournamentmatchsetroundscore[0], turnIndex: index, playerTurn: 0 }))
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass((_ctx.isEditScore && _ctx.scoreDataForEdit.turnIndex == index && _ctx.scoreDataForEdit.playerTurn == 0) && 'selectedField')
                          }, _toDisplayString(tournamentmatchsetroundscore[0]), 3)
                        ], 8, _hoisted_32))
                  ], 8, _hoisted_27))
                }), 128))
              ])
            ], 512)
          ]),
          (_ctx.inhibitNextTurn && _ctx.winningPlayer !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_va_button, {
                    class: "btn mr-2",
                    color: "success",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.approveMatchSetResultsAsFinal()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_35
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.roundsModeData.readOnlyMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_va_input, {
                    ref: "playerscoreinputref",
                    class: "inputField",
                    type: "number",
                    modelValue: _ctx.playerScoreInputValue,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.playerScoreInputValue) = $event)),
                    onKeyup: _cache[4] || (_cache[4] = _withKeys(() => _ctx.isEditScore ? _ctx.submitToEditScore() : (_ctx.isEditRemainingScore ? _ctx.submitToEditRemainingScore(): _ctx.submitAndAdvanceNextTurn()), ["enter"])),
                    placeholder: (this.roundsModeData.status < 2 ? 'Score for ' + _ctx.setPlayersNameFormate(_ctx.labelCurrentPlayerWhoseTurnItIs) : ''),
                    disabled: _ctx.inhibitNextTurn,
                    readonly: ""
                  }, null, 8, ["modelValue", "placeholder", "disabled"]),
                  (_ctx.isEditScore || _ctx.isEditRemainingScore)
                    ? (_openBlock(), _createBlock(_component_va_button, {
                        key: 0,
                        class: "cancelBtn",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearScoreToEdit())),
                        style: {"border-radius":"0"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_38
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("table", _hoisted_39, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: "shortCut",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.shortCut('26')))
                      }, "26"),
                      _createElementVNode("td", {
                        class: "numpadItem",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addNumber('7')))
                      }, "7"),
                      _createElementVNode("td", {
                        class: "numpadItem",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addNumber('8')))
                      }, "8"),
                      _createElementVNode("td", {
                        class: "numpadItem",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addNumber('9')))
                      }, "9"),
                      _createElementVNode("td", {
                        class: "shortCut",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.shortCut('81')))
                      }, "81"),
                      _createElementVNode("td", {
                        class: "shortCut",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.shortCut('180')))
                      }, "180")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: "shortCut",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.shortCut('41')))
                      }, "41"),
                      _createElementVNode("td", {
                        class: "numpadItem",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addNumber('4')))
                      }, "4"),
                      _createElementVNode("td", {
                        class: "numpadItem",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addNumber('5')))
                      }, "5"),
                      _createElementVNode("td", {
                        class: "numpadItem",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addNumber('6')))
                      }, "6"),
                      _createElementVNode("td", {
                        class: "shortCut",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.shortCut('85')))
                      }, "85"),
                      _createElementVNode("td", {
                        class: _normalizeClass((_ctx.dart43Modal ? 'numpadItem' : 'numpadItem dart43Active')),
                        id: "numpadtable_btn_dart43",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.doDart43()))
                      }, "Dart 43", 2)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: "shortCut",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.shortCut('45')))
                      }, "45"),
                      _createElementVNode("td", {
                        class: "numpadItem",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.addNumber('1')))
                      }, "1"),
                      _createElementVNode("td", {
                        class: "numpadItem",
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.addNumber('2')))
                      }, "2"),
                      _createElementVNode("td", {
                        class: "numpadItem",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.addNumber('3')))
                      }, "3"),
                      _createElementVNode("td", {
                        class: "shortCut",
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.shortCut('100')))
                      }, "100"),
                      (!_ctx.isEditRemainingScore)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 0,
                            rowspan: "2",
                            class: _normalizeClass(["numpadItem enter", _ctx.isBustButtonDisabled ? 'disabled_bust' : '']),
                            id: "numpadtable_btn_enter",
                            style: {"font-size":"1.8em"},
                            onClick: _cache[23] || (_cache[23] = () => _ctx.isEditScore ? _ctx.submitToEditScore() : _ctx.submitAndAdvanceNextTurn())
                          }, [
                            _createVNode(_component_va_icon, { name: "keyboard_return" }),
                            _hoisted_40,
                            _createTextVNode(_toDisplayString(_ctx.isEditScore ? 'Godkend' : ( _ctx.playerScoreInputValue.length ? 'Enter' : 'Bust ')), 1)
                          ], 2))
                        : (_openBlock(), _createElementBlock("td", {
                            key: 1,
                            rowspan: "2",
                            class: "numpadItem enter",
                            id: "numpadtable_btn_enter",
                            style: {"font-size":"1.8em"},
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.submitToEditRemainingScore()))
                          }, [
                            _createVNode(_component_va_icon, { name: "keyboard_return" }),
                            _hoisted_41,
                            _hoisted_42
                          ]))
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: "shortCut",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.shortCut('60')))
                      }, "60"),
                      _createElementVNode("td", {
                        class: "numpadItem remove",
                        id: "numpadtable_btn_del",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.deleteLast()))
                      }, " Slet"),
                      _createElementVNode("td", {
                        class: "numpadItem",
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.addNumber('0')))
                      }, "0"),
                      _createElementVNode("td", {
                        class: "numpadItem remove",
                        id: "numpadtable_btn_undo",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.undoToPreviousTurn()))
                      }, " Fortryd"),
                      _createElementVNode("td", {
                        class: "shortCut",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.shortCut('140')))
                      }, "140")
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.resetWarningModal,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.resetWarningModal) = $event)),
      "hide-default-actions": "",
      "overlay-opacity": "0.5",
      "no-dismiss": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_va_button, {
              class: "btn mr-2",
              color: "danger",
              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.resetMatchSetRounds()))
            }, {
              default: _withCtx(() => [
                _hoisted_47
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn ml-2",
              color: "secondary",
              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.resetWarningModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_48
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_43,
        _hoisted_44
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.finalMatchSetRoundsClosingDartsModal,
      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.finalMatchSetRoundsClosingDartsModal) = $event)),
      size: "large",
      "hide-default-actions": "",
      "overlay-opacity": "0.5",
      "no-dismiss": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createVNode(_component_va_button, {
              class: "btn ml-2 m-2",
              style: {"width":"100%!important","height":"55px!important","margin":"12px"},
              color: "secondary",
              onClick: _ctx.cancelFinalMatchSetRoundsClosingDartsModal
            }, {
              default: _withCtx(() => [
                _hoisted_57
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_49,
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.closingNumberOfDartArrowsPossibleOptions, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    onClick: ($event: any) => (_ctx.saveFinalMatchSetRoundsClosingDartArrows(item.value)),
                    style: {"width":"100%!important"}
                  }, [
                    _createVNode(_component_va_button, {
                      disabled: item.disabled,
                      size: "large",
                      style: {"width":"100%!important","height":"65px!important"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled"])
                  ], 8, _hoisted_54))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.dart43Modal,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.dart43Modal) = $event)),
      size: "large",
      "hide-default-actions": "",
      "overlay-opacity": "0.5",
      "no-dismiss": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createVNode(_component_va_button, {
              class: "btn mr-2",
              color: "success",
              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.saveDart43()))
            }, {
              default: _withCtx(() => [
                _hoisted_66
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn ml-2",
              color: "secondary",
              onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.dart43Modal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_67
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_58,
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _hoisted_63,
              _createVNode(_component_va_option_list, {
                type: "radio",
                options: _ctx.playerWhoWonOptions,
                modelValue: _ctx.playerWhoWonValue,
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.playerWhoWonValue) = $event)),
                "value-by": "value"
              }, null, 8, ["options", "modelValue"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.resumeMatchSetModal,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.resumeMatchSetModal) = $event)),
      size: "large",
      "max-width": "720px",
      "hide-default-actions": "",
      "overlay-opacity": "0.5",
      "no-dismiss": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _createVNode(_component_va_button, {
              class: "btn mr-2",
              color: "success",
              onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.resumeMatchSet()))
            }, {
              default: _withCtx(() => [
                _hoisted_76
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_68,
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _hoisted_73,
              _createVNode(_component_va_option_list, {
                type: "radio",
                options: _ctx.resumeMatchSetOptions,
                modelValue: _ctx.resumeMatchSetValue,
                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.resumeMatchSetValue) = $event)),
                "value-by": "value",
                "default-value": _ctx.resumeMatchSetValue
              }, null, 8, ["options", "modelValue", "default-value"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}